import * as z from "zod/v4";

export const updateOrder = {
  name: "updateOrder" as const,
  input: z.object({
    orderId: z.string(),
    lineItemEdits: z
      .array(
        z.object({
          lineItemTitle: z.string(),
          lineItemVariantTitle: z.string(),
          quantity: z.number(),
        }),
      )
      .optional(),
    shippingAddress: z
      .object({
        firstName: z.string(),
        lastName: z.string(),
        address1: z.string(),
        address2: z.string().optional(),
        city: z.string(),
        province: z.string(),
        zip: z.string(),
        countryCode: z.string(),
        phone: z.string().optional(),
      })
      .optional(),
    shippingLine: z
      .object({
        shippingLineId: z.string(),
        title: z.string(),
        price: z.string(),
      })
      .optional(),
    contactInfo: z
      .object({ email: z.email().optional(), phone: z.string().optional() })
      .optional(),
    discountCode: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};

export const updateOrderSchema = { updateOrder };
